import { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import publicRoutes from './routes/PublicRoutes';
import protectedRoutes from './routes/ProtectedRoutes';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {publicRoutes.map((route, index) => (
          <Route path={route.path} element={route.element} key={index} />
        ))}
        {/* <Login /> */}
        {/* Protected Routes */}
          <Route
            path="/"
            // element={<ProtectedRoute />}
          >
            {protectedRoutes?.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
